import { render } from "./RewardsPage.vue?vue&type=template&id=5c5b7a19&scoped=true"
import script from "./RewardsPage.vue?vue&type=script&lang=js"
export * from "./RewardsPage.vue?vue&type=script&lang=js"

import "./RewardsPage.vue?vue&type=style&index=0&id=5c5b7a19&scoped=true&lang=css"

import exportComponent from "/var/www/cmtycoin.xyz/repo/frontend-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c5b7a19"]])

export default __exports__